/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiCaseAttachmentType } from './InternalApiCaseAttachmentType';
import {
    InternalApiCaseAttachmentTypeFromJSON,
    InternalApiCaseAttachmentTypeFromJSONTyped,
    InternalApiCaseAttachmentTypeToJSON,
    InternalApiCaseAttachmentTypeToJSONTyped,
} from './InternalApiCaseAttachmentType';

/**
 * 
 * @export
 * @interface InternalApiAttachToCasesRequest
 */
export interface InternalApiAttachToCasesRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiAttachToCasesRequest
     */
    caseHandles: Array<string>;
    /**
     * 
     * @type {InternalApiCaseAttachmentType}
     * @memberof InternalApiAttachToCasesRequest
     */
    type: InternalApiCaseAttachmentType;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiAttachToCasesRequest
     */
    ids: Array<string>;
}



/**
 * Check if a given object implements the InternalApiAttachToCasesRequest interface.
 */
export function instanceOfInternalApiAttachToCasesRequest(value: object): value is InternalApiAttachToCasesRequest {
    if (!('caseHandles' in value) || value['caseHandles'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('ids' in value) || value['ids'] === undefined) return false;
    return true;
}

export function InternalApiAttachToCasesRequestFromJSON(json: any): InternalApiAttachToCasesRequest {
    return InternalApiAttachToCasesRequestFromJSONTyped(json, false);
}

export function InternalApiAttachToCasesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAttachToCasesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'caseHandles': json['caseHandles'],
        'type': InternalApiCaseAttachmentTypeFromJSON(json['type']),
        'ids': json['ids'],
    };
}

export function InternalApiAttachToCasesRequestToJSON(json: any): InternalApiAttachToCasesRequest {
    return InternalApiAttachToCasesRequestToJSONTyped(json, false);
}

export function InternalApiAttachToCasesRequestToJSONTyped(value?: InternalApiAttachToCasesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'caseHandles': value['caseHandles'],
        'type': InternalApiCaseAttachmentTypeToJSON(value['type']),
        'ids': value['ids'],
    };
}

